import { axiosAjax } from '@app/src/config/axios';

export const accessService = {
  async post(json): Promise<any> {
    try {
      const { data } = await axiosAjax.post(process.env.API_ACCESS, json);
      return data;
    } catch (e) {
      throw new Error(e);
    }
  }
};
